import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { ProductionLineRoute } from '../production-line-route'
import { MatTooltip } from '@angular/material/tooltip'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-production-route',
  templateUrl: './production-route.component.html',
  styleUrls: ['./production-route.component.scss'],
  imports: [MatTooltip, AsyncPipe],
})
export class ProductionRouteComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly route$ = new BehaviorSubject<ProductionLineRoute>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set route(route: ProductionLineRoute) {
    this.route$.next(route)
  }
}
